const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/administrative/EmptyRouterView.vue");
const Administrative = () => /* webpackChunkName: "HomeAdministrative" */ import("./../views/administrative/Home.vue");
const PatientHome = () => /* webpackChunkName: "PatientHome" */ import("./../views/administrative/patient/PatientHome.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/administrative/archive_request/ArchiveRequestHome.vue");
const Archive = () => /* webpackChunkName: "Archive" */ import("./../views/administrative/archive/Archive.vue");

export const routes = [
  {
    path: "/administrativo",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "administrativeHome",
        component: Administrative,
      },
      {
        path: "gestor-pacientes",
        name: "administrativePatientHome",
        component: PatientHome,
      },
      {
        path: "solicitud-archivo",
        name: "administrativeArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "archivo",
        name: "administrativeArchive",
        component: Archive,
      },
    ],
  },
];
